<div class="card bg-white border-white card-view-filter-panel view-filter-panel">

  <div class="card-body">

    <h5 class="card-title view-filter-panel-title">
      {{ title }}
    </h5>

    <div class="d-flex align-items-end">

      <div class="flex-grow-1">
        <ngx-slider [(value)]="lowerValue" [(highValue)]="upperValue" (valueChange)="lowerValueChanged($event)" (highValueChange)="upperValueChanged($event)" (userChangeEnd)="handleSliderChanges()" [options]="sliderOptions"></ngx-slider>
      </div>

      <div class="ml-1">
        <button class="btn btn-sm btn-outline-secondary" (click)="reset()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>

    </div>

    <div class="d-flex justify-content-between mt-3 spacing-3 row">
        <div class="col-md-6">
          <input type="number" #inputLowerValue class="form-control" min="0" [ngModel]="lowerValue | number" [(ngModel)]="lowerValue" />
        </div>
        <div class="col-md-6">
          <input type="number" #inputUpperValue class="form-control" min="0" [ngModel]="upperValue | number" [(ngModel)]="upperValue" />
        </div>
    </div>

  </div>

</div>
